import {
  VERIFY_TOKEN_STARTED,
  VERIFY_TOKEN_END,
  USER_LOGIN_STARTED,
  USER_LOGIN_FAILURE,
  VERIFY_USER_SUCCESS,
  USER_LOGOUT,
} from "../actions/env.action";

// define initial state of auth reducer
const initialState = {
  token: null, // manage the access token
  expiredAt: null, // manage expiry time of the access token
  user: null, // manage the user details
  authLoading: true, // to indicate that the auth API is in progress
  isAuthenticated: false, // consider as a authentication flag
  loginLoading: false, // to indicate that the user signin API is in progress
  loginError: null, // manage the error of the user signin API,
  loginBy: null,
};

// update store based on type and payload and return the state
const auth = (state = initialState, action) => {
  switch (action.type) {
    // verify token - started
    case VERIFY_TOKEN_STARTED:
      return action.payload.silentAuth
        ? {
            ...state,
          }
        : initialState;
    // verify token - ended/failed
    case VERIFY_TOKEN_END:
      return {
        ...state,
        authLoading: false,
      };
    // user login - started
    case USER_LOGIN_STARTED:
      return {
        ...state,
        loginLoading: true,
      };
    // user login - ended/failed
    case USER_LOGIN_FAILURE:
      return {
        ...state,
        loginError: action.payload.error,
        loginLoading: false,
      };
    // verify token - success
    case VERIFY_USER_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        expiredAt: action.payload.expiredAt,
        loginBy: action.payload.loginBy,
        user: action.payload.user,
        isAuthenticated: true,
        authLoading: false,
        loginLoading: false,
      };
    // handle user logout
    case USER_LOGOUT:
      return {
        ...initialState,
        authLoading: false,
      };
    default:
      return state;
  }
};

export default auth;
